/* global SERVER_URL */
import React, { createContext, useEffect, useState } from 'react';
import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import { connect } from 'react-redux';
import { checkHttpStatus, parseJSON, slugify } from '../utils';

export const SnapshotNavContext = createContext(null);
const SnapshotNavContextProvider = ({ children, channelsList = [] }) => {
  const [contests, setContests] = useState([]);
  const [partners, setPartners] = useState([]);
  const [channels, setChannels] = useState([]);
  useEffect(() => {
    fetch(`${SERVER_URL}/snapshots/galleries`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(({ data }) => {
        const {
          contests: contestsData = [],
          partners: partnersData = [],
          channels: channelsData = [],
        } = data;
        setContests(contestsData);
        setPartners(partnersData);
        setChannels(channelsData);
      });
  }, []);
  const resetGalleryMetadata = () => {};

  const contextValue = {
    contests,
    partners,
    channels,
    channelsList,
  };

  return (
    <SnapshotNavContext.Provider value={contextValue}>
      {children}
    </SnapshotNavContext.Provider>
  );
};

const mapStateToPops = (state) => {
  let channels = [];
  if (state.channels.data) {
    channels = _.sortBy(state.channels.data.map((channel) => {
      return {
        title: channel.title,
        slug: slugify(channel.title),
        id: channel.id,
      };
    }), 'title');
  }
  return {
    channelsList: channels,
  };
};

export default connect(mapStateToPops)(SnapshotNavContextProvider);
